/**
 * Model object to handle Duration related operations. Inputs duration in millisecond.
 */
class MillisecondObj {
  constructor(duration) {
    if (duration) {
      this.stamp = duration
      this.hours = Math.floor(duration / 60)
      this.minutes = Math.floor(duration % 60)
    } else {
      this.stamp = ''
      this.hours = ''
      this.minutes = ''
    }
  }

  getDurationInMilliseconds() {
    return this.stamp
  }

  getDuration() {
    return {
      hours: this.hours,
      minutes: this.minutes
    }
  }

  setDuration(duration) {
    this.duration = duration
  }

  // Returns duration in the desired format of hours and minutes
  applyFilter() {
    // TODO: Fix this dependency
    // return $filter('pclnTime')(this);
    return this
  }
}

export { MillisecondObj }
